import useSWR from 'swr';

import type { CommonUserProfile } from '@steadioTypes/user';

export default function useCommonUserProfile() {
  const { data, error, mutate } = useSWR('/api/v1/user/profile', null, {
    revalidateIfStale: false,
    shouldRetryOnError: false,
  });
  const loading = !data && !error;
  const userProfile = data as CommonUserProfile;

  const isSignedOut = error?.status === 401;

  return {
    userProfile,
    error,
    mutate,
    loading,
    isLogin: !isSignedOut,
    isSignedOut,
  };
}
